var PaymentMethodType;
(function (PaymentMethodType) {
    PaymentMethodType["BANCO_DO_BRASIL"] = "banco-do-brasil";
    PaymentMethodType["BRADESCO"] = "BRADESCO";
    PaymentMethodType["CAIXA"] = "caixa";
    PaymentMethodType["NUBANK"] = "nubank";
    PaymentMethodType["SANTANDER"] = "santander";
    PaymentMethodType["PIX"] = "pix";
})(PaymentMethodType || (PaymentMethodType = {}));
var PaymentField;
(function (PaymentField) {
    PaymentField["EMAIL"] = "email";
    PaymentField["BRANCH"] = "branch";
    PaymentField["ACCOUNT"] = "account";
    PaymentField["ACCOUNT_TYPE"] = "accountType";
    PaymentField["PAYMENT_METHOD"] = "paymentMethod";
})(PaymentField || (PaymentField = {}));

export { PaymentField, PaymentMethodType };
